
<ng-template #activeLight>
  <traffic-light [color]="statusToColor[appInfo.status]" [text]="statusToText[appInfo.status]"></traffic-light>
  <div class="unpublish-link" *ngIf="appInfo.status === 'published' && event.can_access" (click)="updateApp('unpublished')">Deactivate</div>
</ng-template>
<ng-template #activeUsers>
  <div class="logged-in" *ngIf="userCount !== undefined">
    Unique users over 24 hours:
    <span class="count">{{ userCount }}</span>
  </div>
</ng-template>
<ng-template #qrCells>
  <div class="message">
    <div class="joi">FOR ANDROID PHONES</div>
    Scan this QR to download the Joi app from the Google Play Store if you haven't already
  </div>
  <qr-code [value]="androidAppStoreLink"></qr-code>
  <div class="message">
    <div class="joi">FOR APPLE PHONES</div>
    Scan this QR to download the Joi app from the iOS store if you haven't already
  </div>
  <qr-code [value]="appleAppStoreLink"></qr-code>
  <!--<qr-code [value]="appLink + 'login/' + appInfo.publishCode"></qr-code>-->
</ng-template>

<black-bar-wrapper
  *ngIf="event && !event.closed && !!appInfo"
  (close)="close.emit()"
>
  <div class="header">{{ appInfo.title }}</div>
  <joi-nav-wrapper class="topMenu" [menuItems]="topMenuItems" [menuMap]="topMenuItemMap" [selectedId]="topMenuItem" (selectItem)="topMenuItem = $event">
  </joi-nav-wrapper>
  <joi-nav-wrapper class="subMenu" *ngIf="topMenuItem === 'app'" [menuItems]="appMenuItems" [hiddenMobileItems]="hiddenAppMenuItems" [menuMap]="appMenuItemMap" [selectedId]="appMenuItem" (selectItem)="appMenuItem = $event">
    <ng-container [ngTemplateOutlet]="activeLight"></ng-container>
  </joi-nav-wrapper>
  <joi-nav-wrapper class="subMenu" *ngIf="topMenuItem === 'comms'" [menuItems]="commMenuItems" [menuMap]="commMenuItemMap" [selectedId]="commMenuItem" (selectItem)="commMenuItem = $event">
    <ng-container [ngTemplateOutlet]="activeLight"></ng-container>
  </joi-nav-wrapper>
  <scrollable-wrapper>
    <!-- PUSH NOTIFICATIONS -->
    <div class="notifications" *ngIf="topMenuItem === 'comms' && commMenuItem === 'notifications'">
      <div class="publish_menu">
        <ng-container [ngTemplateOutlet]="activeUsers"></ng-container>
        <div style="flex:1;" class="disappearing-spacer" ></div>
        <action-button [text]="'CREATE PUSH NOTIFICATION'" (click)="openNotification()"></action-button>
      </div>
      <grey-wrapper class="notifications-wrapper">
        <app-notifications-list #appNotificationList
          (edit)="openNotification($event)"
          [notifications]="appNotifications"
        ></app-notifications-list>
      </grey-wrapper>
      <!--
        <action-button class="testing-button" *ngIf="!appInfo.testingDeviceId" [text]="'Set up a testing phone'" (click)="setupTestingPhone()"></action-button>
        <action-button class="testing-button" *ngIf="!!appInfo.testingDeviceId" [text]="'Clear testing phone'" (click)="clearTestingPhone()"></action-button>
      -->
    </div>

    <!-- EVALUATIONS -->
    <div class="notifications" *ngIf="topMenuItem === 'comms' && commMenuItem === 'forms'">
      <div class="publish_menu">
        <ng-container [ngTemplateOutlet]="activeUsers"></ng-container>
        <div style="flex:1;" class="disappearing-spacer" ></div>
        <action-button [text]="'CREATE EVALUATION FORM'" (click)="createSurvey()"></action-button>
      </div>
      <grey-wrapper class="notifications-wrapper" *ngIf="appInfo.surveyIds | idsToItems:appInfo.surveys as surveys">
        <app-surveys-list #appSurveyList
          [surveys]="appInfo.surveyIds | idsToItems:appInfo.surveys"
          [appId]="appId"
          (pushNow)="pushSurvey($event)"
          (edit)="openSurvey($event)"
          (deactivate)="deactivateSurvey($event)"
          (delete)="deleteSurvey($event)"
          (update)="updateSurvey($event)"
        ></app-surveys-list>
      </grey-wrapper>
    </div>

    <!-- RESPONSES -->
    <survey-responses *ngIf="topMenuItem === 'comms' && commMenuItem === 'responses'" [appId]="appId"></survey-responses>

    <!-- DESIGN -->
    <app-branding *ngIf="topMenuItem === 'app' && appMenuItem === 'design'" [appInfo]="appInfo"></app-branding>
    
    <!-- ACCESS -->
    <div class="access" *ngIf="topMenuItem === 'app' && appMenuItem === 'access'">
      <grey-wrapper>
        <tip-text class="brief-tip" style="margin-bottom: 20px;"
          *ngIf="appInfo?.password !== appInfo?.tempPassword || appInfo?.passwordProtected !== appInfo?.tempPasswordProtected || appInfo?.nameAndEmail !== appInfo?.tempNameAndEmail"
          [type]="'important'" [head]="'Important'" [body]="'These settings will only be updated if you update the app.'"
        ></tip-text>
        <div class="bold-grid">
          <div class="message">Password Protected</div>
          <toggle-tab [bottomTab]="false" [text]="appInfo.passwordProtected ? 'ON' : 'OFF'" [toggled]="!!appInfo.tempPasswordProtected" (toggle)="appInfo.tempPasswordProtected = !appInfo.tempPasswordProtected; updateAppInfo()"></toggle-tab>
          <ng-container *ngIf="!!appInfo.tempPasswordProtected">
            <div class="message">Password</div>
            <joi-input class="password"  
              [(model)]="appInfo.tempPassword" 
              [placeholder]="'Password...'" 
              (joiChange)="updateAppInfo()"
            ></joi-input>
          </ng-container>
          <div class="message">Name and Email required</div>
          <toggle-tab [bottomTab]="false" [text]="appInfo.tempNameAndEmail ? 'ON' : 'OFF'" [toggled]="!!appInfo.tempNameAndEmail" (toggle)="appInfo.tempNameAndEmail = !appInfo.tempNameAndEmail; updateAppInfo()"></toggle-tab>
        </div>
        <div class="hint">Name and email is required if you want to report on who used the app and who responded to evaluations</div>
      </grey-wrapper>
    </div>

    <!-- ACTIVATE -->
    <div class="activate" *ngIf="topMenuItem === 'app' && appMenuItem === 'activate'">
      <div class="publish_menu" *ngIf="!event?.is_readonly">
        <div style="flex:1;" class="disappearing-spacer" ></div>
        <div class="unactivated" *ngIf="appInfo?.status !== 'published'">
          Click ACTIVATE to make your app available for review
        </div>
        <div class="publish-info-holder preview" *ngIf="appInfo?.status !== 'never published'">
          <div class="publish-success" *ngIf="showSuccess">Success!</div>
          <div *ngIf="appInfo.status !== 'never published'" class="publish-info">
            {{ appInfo.status === 'published' ? 'Last updated' : 'Deactivated' }} by {{ appInfo.publisher }} at {{ appInfo.publishedAt | date: 'h:mmaaaaa\'m\' on d MMMM yyyy' }}.
          </div>
        </div>
        <button mat-button color="primary" [disabled]="processing" (click)="updateApp('published')">
          <div class="button_content">
            {{ appInfo.status !== 'published' ? 'ACTIVATE' : 'UPDATE' }}
            <loader icon="button_wheel"></loader>
          </div>
        </button>
      </div>
      <grey-wrapper *ngIf="appInfo?.status === 'published'" class="body-wrapper">
        <div class="bold-grid">
          <ng-container [ngTemplateOutlet]="qrCells"></ng-container>
        </div>
      </grey-wrapper>
    </div>

    <!-- SHARE -->
    <div class="share" *ngIf="topMenuItem === 'app' && appMenuItem === 'share'">
      <div class="empty-share" *ngIf="appInfo?.status !== 'published'" [innerHTML]="helpers.strWithBreak(emptyShareMessage)"></div>
      <grey-wrapper *ngIf="appInfo?.status === 'published'" class="body-wrapper">
        <div class="bold-grid">
          <div class="message">App Store name</div>
          <div class="joi-events">Joi Events</div>
          <div class="message">Event app name</div>
          <div class="copy-holder">
            <grey-wrapper>
              {{ appInfo.title }}
            </grey-wrapper>
            <icon class="copy" [icon]="'COPY'" (click)="copyId()"></icon>
          </div>
          <div class="message">Email Instructions</div>
          <div class="copy-holder">
            <grey-wrapper>
              <div class="instructions" [innerHTML]="helpers.strWithBreak(instructions)"></div>
            </grey-wrapper>
            <icon class="copy" [icon]="'COPY'" (click)="copyInstructions()"></icon>
          </div>
          <ng-container [ngTemplateOutlet]="qrCells"></ng-container>
        </div>
      </grey-wrapper>
    </div>

    <!-- CONFIGURE -->
    <ng-container *ngIf="topMenuItem === 'app' && appMenuItem === 'configure'">
      <div class="top_container">
        <div class="publish_menu" *ngIf="!event?.is_readonly">
          <div class="unpublished-notice">
            Use Display Options and Filter timeline to configure the information showing on these pages
          </div>
          <div style="flex:1;" class="disappearing-spacer" ></div>
          <icon-text [text]="'Display options'" [icon]="'CHECKBOX_FULL'"  (click)="editFields()"></icon-text>
          <icon-text [active]="!!appInfo?.filters?.count" [text]="'Filter timeline'" (click)="openFilters()"></icon-text>
        </div>
      </div>
      <publish-timeline *ngIf="!hideTimeline"
        [title]="appInfo.title" 
        [madeWithJoi]="false" 
        [joiEvent]="eventDataPreview?.eventInfo" 
        [brandingData]="brandingData"
        [homePageData]="appInfo?.homePageData"
        [data]="eventDataPreview?.timeline" 
        [CTALinks]="appInfo.CTALinks"
        [version]="eventDataPreview?.internalVersion"
        [venue]="previewVenue"
        [loading]="loadingPreview"
        [tabNames]="appInfo.tabNames"
        [excludedFieldIds]="appInfo.excludedFieldIds"
        [isConfigure]="true"
        [isApp]="true"
        (change)="changeBrandingOption($event)"
      ><div class="configure-home">
        <branding-text 
          [title]="'Header copy'"
          [brandingText]="appInfo.homePageData.headerText"
          (changed)="updateAppInfo()"
        ></branding-text>
        <branding-text 
          [title]="'Body copy'"
          [brandingText]="appInfo.homePageData.bodyText"
          (changed)="updateAppInfo()"
        ></branding-text>
        <branding-block
          id="slider-block"
          *ngIf="{ count: appInfo.homePageData?.sliderImages?.length || 0 } as s"
          [title]="'Slider Images'"
          [icon]="'scenic'"
          [hideGreyText]="true"
          [greyText]="!s.count ? 'NO SLIDER IMAGES ADDED' : (s.count + ' SLIDER IMAGE' + ( s.count > 0 ? 's' : '') + ' ADDED')"
          [changeText]="'+ ADD SLIDER IMAGE'"
          (change)="editSliderImage(null)"
        ><div class="slider-images-holder">
          <div class="slider-image" *ngFor="let image of (appInfo?.homePageData?.sliderImages || []); index as i;">
            <slider-image [sliderImage]="image"></slider-image>
            <div class="image-hover" (click)="editSliderImage(i)">
              <icon [icon]="'camera'"></icon>
            </div>
          </div>
        </div>
        </branding-block>
      </div>
      
      </publish-timeline>
    </ng-container>

  </scrollable-wrapper>
</black-bar-wrapper>
